import { render, staticRenderFns } from "./UploadPicture.vue?vue&type=template&id=56e16996&scoped=true&"
import script from "./UploadPicture.vue?vue&type=script&lang=js&"
export * from "./UploadPicture.vue?vue&type=script&lang=js&"
import style0 from "./UploadPicture.vue?vue&type=style&index=0&id=56e16996&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e16996",
  null
  
)

export default component.exports